'use client'

import { useState } from 'react'
import Image from 'next/image'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { ZoomIn } from 'lucide-react'

interface NewsImageViewerProps {
  src: string
  alt: string
  category: string
}

export function NewsImageViewer({ src, alt, category }: NewsImageViewerProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        className="group relative cursor-pointer rounded-lg overflow-hidden block w-full"
        onClick={() => setOpen(true)}
        aria-label={`${alt}を拡大表示`}
      >
        {category === 'メディア掲載' ? (
          <div className="relative w-full h-auto">
            <Image
              src={src}
              alt={alt}
              width={1920}
              height={1080}
              className="w-full h-auto transition-opacity group-hover:opacity-90"
              priority
            />
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/20">
              <div className="bg-white/90 rounded-full p-3">
                <ZoomIn className="h-6 w-6 text-gray-900" />
              </div>
            </div>
          </div>
        ) : (
          <div className="relative aspect-video">
            <Image
              src={src}
              alt={alt}
              fill
              className="object-cover transition-opacity group-hover:opacity-90"
              priority
            />
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/20">
              <div className="bg-white/90 rounded-full p-3">
                <ZoomIn className="h-6 w-6 text-gray-900" />
              </div>
            </div>
          </div>
        )}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-7xl w-full p-0 bg-transparent border-none">
          <DialogTitle className="sr-only">画像拡大表示</DialogTitle>
          {open && (
            <div className="relative w-full h-[80vh]">
              <Image
                src={src}
                alt={alt}
                fill
                className="object-contain"
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  )
}
